import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { ProjectSetupData } from "../types";
import * as styles from "./styles_vanilla.css";

interface ProjectSetupConfigurationProps {
  projectSetup: ProjectSetupData;
}

const ProjectSetupConfiguration: React.FC<ProjectSetupConfigurationProps> = ({
  projectSetup,
}) => {
  return (
    <Flex flexDirection="column" gap={Sizes.LG}>
      <Flex className={styles.sectionHeader}>
        <Flex className={styles.sectionIcon}>
          <Icon type="cog" size="medium" color={Colors.Neutral600} />
        </Flex>
        <Flex flexDirection="column">
          <Text className={styles.sectionTitle}>Project Setup Configuration</Text>
          <Text className={styles.sectionSubtitle}>
            Review the project details configured in Step 1
          </Text>
        </Flex>
      </Flex>

      <Flex className={styles.configGrid}>
        <Flex flexDirection="column" className={styles.configField}>
          <Text className={styles.fieldLabel}>Arena Domain Name</Text>
          <Text className={styles.fieldValue}>{projectSetup.arenaDomainName}</Text>
        </Flex>
        <Flex flexDirection="column" className={styles.configField}>
          <Text className={styles.fieldLabel}>Job Name</Text>
          <Text className={styles.fieldValue}>{projectSetup.jobName}</Text>
        </Flex>
        <Flex flexDirection="column" className={styles.configField}>
          <Text className={styles.fieldLabel}>Arena User Email</Text>
          <Text className={styles.fieldValue}>{projectSetup.arenaUserEmail}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ProjectSetupConfiguration;
